module.exports = __webpack_public_path__ + "img/3stars.1ef96451.jpg";